var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.129a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75m0 10.875a6 6 0 1 0 0-12 6 6 0 0 0 0 12M5.102 5.105a.56.56 0 0 0 0 .795L6.203 7 5.102 8.104a.562.562 0 0 0 .795.795l1.1-1.102L8.1 8.898a.562.562 0 0 0 .795-.795L7.792 7.002 8.894 5.9a.562.562 0 0 0-.795-.795L6.998 6.207 5.896 5.105a.56.56 0 0 0-.794 0"
  })));
};
export default SvgXCircle;